/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
import { net } from 'zf-web-infra';
import { createWWLoginPanel, WWLoginType, WWLoginRedirectType, WWLoginPanelSizeType } from '@wecom/jssdk';
import type { WWLoginSuccessResp } from '@wecom/jssdk';
import type * as Types from '../types';

export class WeComLoginService {

  async init(tenant: string, config: Types.WeComLoginSettingResponse): Promise<WWLoginSuccessResp> {
    const { corpId, agentId } = config;
    const redirect_uri = this.getRedirectUrl(tenant);
    return await new Promise((resolve, reject) => {
      createWWLoginPanel({
        el: '#login-qrcode',
        params: {
          login_type: WWLoginType.corpApp,
          redirect_uri,
          appid: corpId,
          agentid: agentId,
          state: 'wecomQRLogin',
          redirect_type: WWLoginRedirectType.callback,
          panel_size: WWLoginPanelSizeType.small
        },
        onLoginSuccess(result) {
          resolve(result);
        },
        onLoginFail(err) {
          reject(err);
        }
      });
    });
  }

  async login(params: { authCode: string; tenant: string; app: string }): Promise<Types.LoginResponse> {
    return await net.post<Types.LoginResponse>('/api/account/wecomQRLogin', params);
  }

  async fetchConfig(params: { tenant: string }): Promise<Types.WeComLoginSettingResponse> {
    return await net.get<Types.WeComLoginSettingResponse>('/api/account/wecomQRLoginSetting', params);
  }

  private getRedirectUrl(tenant: string): string {
    return `${window.location.origin}/login?tenant=${tenant}&type=wecom`;
  }

}
